import { useState, useEffect } from "react";
import { ReactComponent as ArrowDown } from "../../../assets/icons/arrowDownSimple.svg";
import { ReactComponent as ArrowUp } from "../../../assets/icons/arrowUpSimple.svg";
import { replaceTextLinks } from "../../constructor/umas/Actividades/ActividadesUtils/ActividadesUtils";
import ImagenValidada from "../../constructor/umas/Actividades/ActividadesUtils/RecursosValidados/ImagenValidada";

export default function Colapsable({ texto1, texto2, imagen, tipo, isGeneratingPDF = false }) {
  const [dropDown, setDropDown] = useState(isGeneratingPDF);

  // En PDF sin imagen, las reservas de espacio para la imagen (arriba a la
  // derecha) y para el botón de colapsar (ausente en PDF) quedan vacías y
  // dejan un hueco grande entre el título y el contenido. Se colapsan solo en
  // ese caso: el visor interactivo/examen y el PDF CON imagen no cambian.
  const sinImagenPDF = isGeneratingPDF && !imagen;

  return (
    <div className="relative my-4 w-full">
      <div className={`visor overflow-hidden z-[2]  grid w-full justify-items-start gap-x-6 rounded-md h-min p-6 relative border shadow ${sinImagenPDF ? "" : "min-h-[15rem] pb-12"}`}>
        <ImagenValidada
          src={imagen}
          className={`relative mx-auto md:absolute right-0 top-0 -z-[1] w-[14rem] h-[14rem] md:mt-2 md:mr-2 rounded-lg  ${
            tipo === "CORTADA"
              ? "object-cover"
              : tipo === "COMPLETA"
              ? "object-contain"
              : "object-fill"
          }`}
        />
        <div className="flex gap-x-6 px-3 w-full relative">
          <div
            dangerouslySetInnerHTML={{ __html: replaceTextLinks(texto1) }}
            className={`w-full items-center pt-6 ${sinImagenPDF ? "" : "md:pr-[235px] min-h-[9rem] md:pt-12"}`}
          ></div>
        </div>
        <div className={`grid transition-all duration-300 ${dropDown ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
          <div className="overflow-hidden">
            <div className={`px-3 w-full ${sinImagenPDF ? "pt-2" : "md:pt-20"}`}>
              <div dangerouslySetInnerHTML={{ __html: replaceTextLinks(texto2) }}></div>
            </div>
          </div>
        </div>
        {!isGeneratingPDF && (
          <div
            className="absolute cursor-pointer h-10 w-14 flex justify-center items-center  bg-white left-1/2 -translate-y-1/2 bottom-[-20px] rounded-tl-[99px] rounded-tr-[99px] rounded-bl-none rounded-br-none shadow border"
            onClick={() => setDropDown(!dropDown)}
          >
            <div className={!dropDown ? "animate-bounce" : ""}>
              <div
                className={`w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[13px] border-t-nimbusDark rounded-b-lg mt-2 transition-transform duration-300 ${
                  dropDown ? "rotate-180" : ""
                }`}
              ></div>
            </div>
          </div>
        )}
      </div>
      {!isGeneratingPDF && (
        <div className="absolute bottom-[-1rem] left-[50.1%] h-[18px] w-[54.5px] bg-white z-[3]" />
      )}
    </div>
  );
}
